/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import JobTaskFileNameChooser, {
  JobTaskFileNameChooserProps
} from './JobTaskFileNameChooser';
import JobTaskSearchChooser from './JobTaskSearchChooser';
import {isCustomSearchTask} from './JobTaskSearchUtils';

/**
 * Defines the `JobTaskFileChooser` wrapper component implementation which simply
 * determines the type of Job Task File Chooser to be rendered, either a custom
 * search chooser; i.e. `JobTaskSearchChooser`, or the default search chooser;
 * i.e. `JobTaskFileNameChooser`.
 *
 * ```typescript
 *  <JobTaskFileChooser row={row}
 *    accountId={accountId}
 *    includeSubAccounts={includeSubAccounts}
 *    onChange={handleFileName(index, tasks)} />
 * ```
 *
 *
 * If the provided `task` prop (via `row.task`) requires a custom Search to
 * be  performed, the `JobTaskSearchChooser` component will be rendered and
 * will subsequently render the corresponding Custom Search component for the
 * given `task`, otherwise, the default `JobTaskFileNameChooser` component
 * will be rendered.
 *
 * @see {@link JobTaskFileNameChooser}
 * @see {@link JobTaskSearchChooser}
 * @see {@link isCustomSearchTask}
 */
export const JobTaskFileChooser = (props: JobTaskFileNameChooserProps) => {
  if (props?.useSearchChooser || isCustomSearchTask(props.row?.task)) {
    return <JobTaskSearchChooser {...props} />;
  }
  return <JobTaskFileNameChooser {...props} />;
};

export default JobTaskFileChooser;
